module.exports = __webpack_public_path__ + "img/winter.6e5bee70.jpg";